module.exports = __webpack_public_path__ + "static/media/Technikraum_BG.7c175d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/machine-room/Technikraum_BG.png
// module id = 528
// module chunks = 0